import ProfilePic from '../../../../../assets/iconos/perf360.svg';
import './ContactCard.css';

const ContactCard = (props) => {


    return(
        <div className="buzon-user-card">
            <img className='buzon-user-card-img' src={props.user.url_profile_pic || ProfilePic}/>
            <h2 className='buzon-user-card-name'>{props.user.name}</h2>
            <button className='green-btn buzon-user-card-button' onClick={() => props.buttonAction.callback(props.user.id)}>
                {props.buttonAction.title}
            </button>
        </div>
    );
}

export default ContactCard;